<section class="validate-container">
  <opath-core-nav-header #header [title]="translation.title" [hideFilterPanel]="true"> </opath-core-nav-header>
  @if (!validationResult) {
    <div fxLayout="column" fxLayoutAlign="center center" class="validate-result">
      <i class="icon dx-icon-info"></i>
      <h3>{{ translation?.expressionChanged }}</h3>
    </div>
  }

  @if (validationResult) {
    @if (
      (validationResult.RefObjectTypeName && validationType === ValidationType.Query) ||
      (validationResult.ValueCount && validationType === ValidationType.Column)) {
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        >
        <i class="icon dx-icon-todo"></i>
        <h3>{{ translation?.valid }}</h3>
      </div>
    } @else {
      <div fxLayout="column" fxLayoutAlign="center center" class="invalid-result">
        <i class="icon dx-icon-close big"></i>
        <h3>{{ translation?.invalid }}</h3>
        @if (validationResult.Errors.length) {
          @for (error of validationResult.Errors; track error) {
            <div fxLayout="row" fxLayoutAlign="start center">
              <i class="icon dx-icon-close" fxFlex="10%"></i>
              <p>{{ error.Message }}</p>
            </div>
          }
        } @else {
          <div fxLayout="row" fxLayoutAlign="start center">
            <i class="icon dx-icon-close" fxFlex="10%"></i>
            <div>
              <p>{{ translation?.typeError }}</p>
              <p>{{ translation?.isRefError }}</p>
            </div>
          </div>
        }
      </div>
    }
  }

  <div fxLayout="column" fxLayoutAlign="center center">
    <abc-button width="80px" height="35px" (click)="executeValidation()" class="validate-button">
      <div *dxTemplate="let data of 'content'">
        @if (loadingValidation) {
          <abc-load-indicator width="22px" height="22px" [visible]="loadingValidation"> </abc-load-indicator>
        } @else {
          {{ translation?.button }}
        }
      </div>
    </abc-button>
  </div>
</section>
